
import Login from "./Routes/Account/Login";
import ProtectedRoutes from "../middleWare/ProtectedRouting/ProtectedRoute";
import { Routes, Route, Navigate } from 'react-router-dom'
import Home from "./Routes/Home";
import ContactUs from "./Routes/ContactUs/Index";
import Inventory from "./Routes/Inventory";
import AboutUs from "./Routes/AboutUs/Index";
import Partner from "./Routes/Partner";
import More from "./Routes/More/Index";
import SalesCrm from "./Routes/SalesCrm/Index";
import Story from "./Routes/Story/Index";
import BeSpoke from "./Routes/BeSpoke/Index";
import PartnerProgram from "./Routes/PartnerProgram/Index";
import DataPage from "./Routes/DataPage/Index";
import TestimonialsPage from "./Routes/TestimonialsPage/Index";






const MainComponent = () => {
    return (
        <Routes>
            <Route path='/login' element={<Login />} />
            <Route path='/homePage' element={<Home />} />
            <Route path='/ContactUS' element={<ContactUs />} />
            <Route path='/Inventory' element={<Inventory />} />
            <Route path='/AboutUs' element={<AboutUs />} />
            <Route path='/Partner' element={<Partner />} />
            {/* <Route path='/More' element={<More/>} /> */}
            <Route path='/SaleCrm' element={<SalesCrm />} />
            <Route path='/Bespoke' element={<BeSpoke/>}/>
            <Route path='/Story' element={<Story/>}/>
            <Route path='/PartnerProgram' element={<PartnerProgram/>}/>
            <Route path='/DataPage' element={<DataPage/>}/>
            <Route path='/TestimonialsPage' element={<TestimonialsPage/>}/>
          
            






            <Route element={<ProtectedRoutes />}>
                {/* <Route path="/Dashboard" element={<Dashboard />} /> */}
            </Route>
            <Route
                path="*"
                element={<Navigate to="/homePage" replace />}
            />
        </Routes>
    );
}

export default MainComponent;